import React, { useState } from "react";
import "./NewPassword.css";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import { resetPassword } from "../../../api/auth";
import { tokenStorage } from "../../../api/index";
import Loader from "../../Loader";

function NewPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const passwordOnChange = (e) => {
    setPassword(e.target.value);
    if (passwordError) {
      setPasswordError("");
    }
  };

  const confirmPasswordOnChange = (e) => {
    setConfirmPassword(e.target.value);
    if (confirmPasswordError) {
      setConfirmPasswordError("");
    }
  };

  const validatePassword = (value, setError) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    if (value.length > 0 && value.length < 8) {
      setError("Password must be at least 8 characters");
      return false;
    }

    if (value.length > 0 && !passwordRegex.test(value)) {
      setError(
        "Password must include uppercase, lowercase, number, and special character"
      );
      return false;
    }

    setError("");
    return true;
  };

  const handleOnBlur = () => {
    validatePassword(password, setPasswordError);
    validatePassword(confirmPassword, setConfirmPasswordError);
  };

  const handleUpdatePassword = async () => {
    if (isLoading) {
      return;
    }
    if (!password || !confirmPassword) {
      setConfirmPasswordError("Please enter both fields");
      return;
    }
    setIsLoading(true);
    const isPasswordValid = validatePassword(password, setPasswordError);
    const isConfirmValid = validatePassword(
      confirmPassword,
      setConfirmPasswordError
    );

    if (password !== confirmPassword) {
      setPasswordError("");
      setConfirmPasswordError("Passwords don't match");
      setIsLoading(false);
      return;
    }

    try {
      const data = await resetPassword({
        token: tokenStorage.getToken(),
        newPassword: password,
      });
      console.log(" response from resetPassword APi:", data);
      dispatch(setActiveComponent("passwordChanged"));
    } catch (error) {
      setConfirmPasswordError("Something went wrong, please try again");
      console.log("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="NewPassword">
      <div className="newPasswordContainer">
        <span className="signInText">New Password</span>
        <div className="passwordInputContainer">
          <div className="generalInputContainer">
            <label htmlFor="password" className="labelText">
              Password
            </label>
            <div className="inputContainerWrapper">
              <input
                className="input"
                type={showPassword ? "text" : "password"}
                placeholder="Type your password"
                value={password}
                onChange={(e) => passwordOnChange(e)}
                onBlur={handleOnBlur}
              />
              <span
                className="eyeIcon"
                onClick={() => {
                  setShowPassword((prev) => !prev);

                  if (showConfirmPassword) {
                    setShowConfirmPassword(false);
                  }
                }}
              >
                {showPassword ? (
                  <RemoveRedEyeRoundedIcon
                    sx={{
                      fontSize: {
                        xs: "12px",   // extra-small devices
                        sm: "14px",   // small devices
                        md: "16px",   // medium devices
                        lg: "18px",   // large devices
                        xl: "20px",   // extra-large devices
                      },
                    }}
                  />
                ) : (
                  <VisibilityOffRoundedIcon
                    sx={{
                      fontSize: {
                        xs: "12px",   // extra-small devices
                        sm: "14px",   // small devices
                        md: "16px",   // medium devices
                        lg: "18px",   // large devices
                        xl: "20px",   // extra-large devices
                      },
                    }}
                  />
                )}
              </span>
              {passwordError && (
                <span className="errorTooltip">{passwordError}</span>
              )}
            </div>
          </div>
          <div className="generalInputContainer">
            <label htmlFor="password" className="labelText">
              Confirm Password
            </label>
            <div className="inputContainerWrapper">
              <input
                className="input"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Type your password"
                value={confirmPassword}
                onChange={(e) => confirmPasswordOnChange(e)}
                onBlur={handleOnBlur}
              />
              <span
                className="eyeIcon"
                onClick={() => {
                  setShowConfirmPassword((prev) => !prev);

                  if (showPassword) {
                    setShowPassword(false);
                  }
                }}
              >
                {showConfirmPassword ? (
                  <RemoveRedEyeRoundedIcon
                    sx={{
                      fontSize: {
                        xs: "12px",   // extra-small devices
                        sm: "14px",   // small devices
                        md: "16px",   // medium devices
                        lg: "18px",   // large devices
                        xl: "20px",   // extra-large devices
                      },
                    }}
                  />
                ) : (
                  <VisibilityOffRoundedIcon
                    sx={{
                      fontSize: {
                        xs: "12px",   // extra-small devices
                        sm: "14px",   // small devices
                        md: "16px",   // medium devices
                        lg: "18px",   // large devices
                        xl: "20px",   // extra-large devices
                      },
                    }}
                  />
                )}
              </span>
              {confirmPasswordError && (
                <span className="errorTooltip">{confirmPasswordError}</span>
              )}
            </div>
          </div>
        </div>
        <button className="btnContainer" onClick={handleUpdatePassword}>
          {isLoading ? <Loader /> : <span className="btnText">Update Password</span>}
        </button>
      </div>
    </div>
  );
}

export default NewPassword;
